module.exports = __webpack_public_path__ + "img/GVC009.e537b8f0.png";